import React from "react";
import PortfolioAlternating from "./reusables/PortfolioAlternating";

const Works = React.memo(() => {
	const renderPortfolioLayout = () => {
		return <PortfolioAlternating />;
	};

	return (
		<section id='Portfolio' className='isolate bg-transparent py-20 sm:py-20' aria-labelledby='portfolio-heading'>
			<div className='mx-auto max-w-7xl px-4 lg:px-16'>
				<div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-none'>
					<header className='md:max-w-lg md:pr-10 lg:max-w-lg lg:pr-30'>
						<div className='hidden sm:flex sm:justify-left'>
							<div className='border-b-8 border-gray-900 w-32 my-6' aria-hidden='true'></div>
						</div>
						<h2 id='portfolio-heading' className='mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl text-center sm:text-left'>
							SELECTED WORKS
						</h2>
						<p className='mt-6 text-lg leading-8 text-gray-600'>
							Take a look at some of my projects I have done.
						</p>
					</header>

					<div className='mt-10'>
						<div role='region' aria-label='Portfolio projects showcase'>
							{renderPortfolioLayout()}
						</div>
					</div>
				</div>

			</div>
		</section>
	);
});

Works.displayName = 'Works';

export default Works;
